/* Horizon P4 (9.10.2026, decision D9): copy of the live assets/batida-drawer.js (b2c-redesign @ b5ff7de) with ONE addition, marked "Horizon P4" below: every cart read / change of the drawer has a deadline, one retry and a visible message with a retry button (live: .catch(function(){}) = a blank or stale drawer, no word to the customer); failures are logged to Clarity as cart_err drawer_*. The requests themselves (/cart.js, /cart/change.js, /cart/add.js, the add payload) are unchanged. File is ADAPTED in the sync manifest: re-apply this block when re-syncing. 15.10.2026 (THM-19): stored formatted (prettier 3.6.2, print width 140, single quotes) instead of minified; the parsed code is identical to the minified file (acorn AST compare). Shopify's CDN minifies it for visitors. Edit this readable version. */
(function () {
  if (window.__batidaDrawerLoaded) return;
  window.__batidaDrawerLoaded = !0;
  var __batidaLang = (document.documentElement.lang || '').toLowerCase().split('-')[0],
    __batidaUkDrawer = {
      title: '\u0422\u0432\u0456\u0439 \u043A\u043E\u0448\u0438\u043A',
      close: '\u0417\u0430\u043A\u0440\u0438\u0442\u0438',
      empty: '\u0422\u0432\u0456\u0439 \u043A\u043E\u0448\u0438\u043A \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u0439.',
      continue_shopping: '\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0438',
      subtotal: '\u0421\u0443\u043C\u0430',
      checkout: '\u041E\u0431\u0440\u0430\u0442\u0438 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443',
      remove: '\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438',
      with_inscription: '(\u0437 \u043D\u0430\u043F\u0438\u0441\u043E\u043C)'
    };
  function __batidaDrawerT(k, fb) {
    return __batidaLang === 'uk' && __batidaUkDrawer[k] ? __batidaUkDrawer[k] : window.batidaT('cart_drawer.' + k, fb);
  }
  var tx = {
      title: __batidaDrawerT('title', 'Tw\xF3j koszyk'),
      close: __batidaDrawerT('close', 'Zamknij'),
      empty: __batidaDrawerT('empty', 'Tw\xF3j koszyk jest pusty.'),
      continue_shopping: __batidaDrawerT('continue_shopping', 'Kontynuuj zakupy'),
      subtotal: __batidaDrawerT('subtotal', 'Suma'),
      checkout: __batidaDrawerT('checkout', 'Przejd\u017a dalej'),
      remove: __batidaDrawerT('remove', 'Usu\u0144'),
      letter_label: __batidaDrawerT('letter_label', 'Tre\u015B\u0107 listu'),
      with_inscription: __batidaDrawerT('with_inscription', '(z napisem)'),
      merch_preorder: __batidaDrawerT('merch_preorder', 'Preorder - wysy\u0142ka 20 pa\u017Adziernika'),
      delivery: __batidaDrawerT('delivery', 'Dostawa'),
      discount_row: __batidaDrawerT('discount_row', 'Rabat ([title])')
    },
    DRAWER_ID = 'batida-cart-drawer',
    BADGE_CLASS = 'batida-cart-badge',
    css =
      '.batida-cart-drawer{position:fixed;inset:0;z-index:9999;visibility:hidden}.batida-cart-drawer:not([hidden]){visibility:visible}.batida-cart-drawer [hidden]{display:none !important}.batida-cart-drawer__backdrop{position:absolute;inset:0;background:rgba(43,32,23,0);transition:background .25s ease;cursor:pointer}.batida-cart-drawer.is-open .batida-cart-drawer__backdrop{background:rgba(43,32,23,.45)}.batida-cart-drawer__panel{position:absolute;top:0;right:0;bottom:0;width:420px;max-width:100vw;background:var(--v7-bg,#fdfaf6);display:flex;flex-direction:column;transform:translateX(100%);transition:transform .28s cubic-bezier(.4,0,.2,1);box-shadow:-2px 0 28px rgba(0,0,0,.12)}.batida-cart-drawer.is-open .batida-cart-drawer__panel{transform:translateX(0)}@media(max-width:480px){.batida-cart-drawer__panel{width:100vw}}.batida-cart-drawer__header{display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid #e3d5ca;background:#fff}.batida-cart-drawer__title{font-size:12px;letter-spacing:.1em;text-transform:uppercase;color:#5a4a3e;margin:0;font-weight:500}.batida-cart-drawer__close{background:0 0;border:0;font-size:26px;line-height:1;cursor:pointer;color:#5a4a3e;padding:0;width:32px;height:32px;display:flex;align-items:center;justify-content:center}.batida-cart-drawer__close:hover{color:var(--v7-ink,#2b2017)}.batida-cart-drawer__items{flex:1;overflow-y:auto;padding:4px 22px}.batida-cart-drawer__line{display:grid;grid-template-columns:72px 1fr auto;gap:14px;padding:16px 0;border-bottom:1px solid #f0e6dc}.batida-cart-drawer__line:last-child{border-bottom:0}.batida-cart-drawer__line__img{width:72px;height:72px;border-radius:6px;overflow:hidden;background:#f0e6dc}.batida-cart-drawer__line__img img{width:100%;height:100%;object-fit:cover;display:block}.batida-cart-drawer__line__body{min-width:0;display:flex;flex-direction:column;gap:4px}.batida-cart-drawer__line__title{font-size:14px;color:var(--v7-ink,#2b2017);margin:0;line-height:1.3;font-weight:500}.batida-cart-drawer__line__title a{color:inherit;text-decoration:none}.batida-cart-drawer__line__title a:hover{text-decoration:underline}a.batida-cart-drawer__line__img{display:block}.batida-cart-drawer__line__variant{font-size:11px;color:#8a7868;margin:0;line-height:1.3}.batida-cart-drawer__line__pre{font-size:12px;color:var(--v7-rasp,#b84a52);margin:0;line-height:1.35;font-weight:600}.batida-cart-drawer__line__price{font-size:13px;color:var(--v7-ink,#2b2017);font-weight:500;margin:4px 0 6px}.batida-cart-drawer__line__qty{display:flex;align-items:center;gap:4px;margin-top:auto}.batida-cart-drawer__line__qty button{width:26px;height:26px;border:1px solid #e3d5ca;background:var(--v7-bg,#fdfaf6);border-radius:4px;cursor:pointer;color:#5a4a3e;font-size:14px;display:flex;align-items:center;justify-content:center;padding:0}.batida-cart-drawer__line__qty input{width:32px;text-align:center;border:0;background:0 0;font-size:13px;color:var(--v7-ink,#2b2017);padding:0}.batida-cart-drawer__line__remove{background:0 0;border:0;cursor:pointer;color:#8a7868;font-size:18px;line-height:1;align-self:start;padding:4px}.batida-cart-drawer__footer{padding:18px 22px 22px;border-top:1px solid #e3d5ca;background:#fff}.batida-cart-drawer__subtotal{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:14px}.batida-cart-drawer__subtotal span{font-size:11px;color:#8a7868;text-transform:uppercase;letter-spacing:.08em}.batida-cart-drawer__subtotal strong{font-size:18px;color:var(--v7-ink,#2b2017);font-weight:500}.batida-cart-drawer__cta-primary{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;padding:14px 18px;background:var(--v7-ink,#2b2017);color:#fff;border:0;border-radius:6px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;font-weight:500;cursor:pointer;text-decoration:none}.batida-cart-drawer__cta-primary:hover{background:#3d2f24;color:#fff;text-decoration:none}.batida-cart-drawer__cta-secondary{width:100%;padding:11px 16px;background:0 0;color:#5a4a3e;border:1px solid #e3d5ca;border-radius:6px;font-size:11px;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;margin-top:8px}.batida-cart-drawer__empty{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 24px;text-align:center}.batida-cart-drawer__empty p{color:#8a7868;margin:0 0 24px;font-size:14px}.batida-cart-drawer__error{padding:12px 22px;background:#fff5f5;color:#9a3030;border-bottom:1px solid #f0d5d5;font-size:13px}body.batida-cart-drawer-open{overflow:hidden}.batida-cart-drawer__gift{display:grid;grid-template-columns:auto minmax(0,1fr);gap:14px;padding:16px 0;border-bottom:1px solid #f0e6dc}.batida-cart-drawer__gift .batida-cart-drawer__line__img{display:block}.batida-cart-drawer__gift__list{margin:2px 0 4px;padding:0 0 0 16px;font-size:12px;line-height:1.45;color:#5a4a3e}.batida-cart-drawer__gift__list li{margin:0;padding:0}.batida-cart-drawer__gift__rm{align-self:start;background:0 0;border:0;padding:0;font:inherit;font-size:12px;color:#8a7868;text-decoration:underline;cursor:pointer}.btn--add-to-cart.is-loading{opacity:.6;pointer-events:none}',
    styleEl = document.createElement('style');
  ((styleEl.id = 'batida-cart-drawer-styles'),
    (styleEl.textContent = css),
    (document.head || document.documentElement).appendChild(styleEl));
  function formatPLN(c) {
    if (window.batidaMoney) return window.batidaMoney(c || 0);
    var a = (c || 0) / 100;
    return a.toFixed(2).replace('.', ',') + ' z\u0142';
  }
  function escapeHtml(s) {
    return (s || '').toString().replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }
  function ensureDrawer() {
    if (!getDrawer()) {
      var d = document.createElement('div');
      ((d.id = DRAWER_ID),
        (d.className = 'batida-cart-drawer'),
        d.setAttribute('aria-hidden', 'true'),
        (d.hidden = !0),
        (d.innerHTML =
          '<div class="batida-cart-drawer__backdrop" data-batida-cart-close></div><aside class="batida-cart-drawer__panel" role="dialog" aria-modal="true" aria-label="' +
          tx.title +
          '"><header class="batida-cart-drawer__header"><h2 class="batida-cart-drawer__title">' +
          tx.title +
          '</h2><button type="button" class="batida-cart-drawer__close" data-batida-cart-close aria-label="' +
          tx.close +
          '">&times;</button></header><div class="batida-cart-drawer__items" data-batida-cart-items></div><div class="batida-cart-drawer__empty" data-batida-cart-empty hidden><p>' +
          tx.empty +
          '</p><button type="button" class="batida-cart-drawer__cta-secondary" data-batida-cart-close>' +
          tx.continue_shopping +
          '</button></div><footer class="batida-cart-drawer__footer" data-batida-cart-footer hidden><div class="batida-cart-drawer__discounts" data-batida-cart-discounts hidden></div><div class="batida-cart-drawer__subtotal"><span>' +
          tx.subtotal +
          '</span><strong data-batida-cart-subtotal>0 zl</strong></div><a href="/cart" class="batida-cart-drawer__cta-primary" data-batida-cart-skip>' +
          tx.checkout +
          ' <span aria-hidden="true">&rarr;</span></a><button type="button" class="batida-cart-drawer__cta-secondary" data-batida-cart-close>' +
          tx.continue_shopping +
          '</button></footer></aside>'),
        document.body.appendChild(d));
    }
  }
  var __batidaPreviouslyFocused = null;
  function __batidaGetFocusable(d) {
    return d.querySelectorAll('button:not([disabled]),[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])');
  }
  function openDrawer() {
    ensureDrawer();
    var d = getDrawer();
    __batidaPreviouslyFocused = document.activeElement;
    try {
      var __r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
        __a = d.querySelector('.batida-cart-drawer__cta-primary[data-batida-cart-skip]');
      __a && __a.setAttribute('href', __r.replace(/\/$/, '') + '/cart');
    } catch {}
    ((d.hidden = !1),
      d.setAttribute('aria-hidden', 'false'),
      document.body.classList.add('batida-cart-drawer-open'),
      requestAnimationFrame(function () {
        (d.classList.add('is-open'),
          setTimeout(function () {
            var closeBtn = d.querySelector('[data-batida-cart-close]:not(.batida-cart-drawer__backdrop)');
            if (closeBtn)
              try {
                closeBtn.focus();
              } catch {}
            else {
              var f = __batidaGetFocusable(d);
              if (f.length > 0)
                try {
                  f[0].focus();
                } catch {}
            }
          }, 50));
      }),
      fetchAndRender());
  }
  function closeDrawer() {
    setDrawerError(null);
    var d = getDrawer();
    d &&
      (d.classList.remove('is-open'),
      document.body.classList.remove('batida-cart-drawer-open'),
      setTimeout(function () {
        if (
          ((d.hidden = !0),
          d.setAttribute('aria-hidden', 'true'),
          __batidaPreviouslyFocused && typeof __batidaPreviouslyFocused.focus == 'function')
        ) {
          try {
            __batidaPreviouslyFocused.focus();
          } catch {}
          __batidaPreviouslyFocused = null;
        }
      }, 280));
  }
  function isMerch(item) {
    return String(item.product_type || '').toLowerCase() === 'merch' || (window.__batidaMerchIds || []).indexOf(item.product_id) >= 0;
  }
  function variantOf(item) {
    var v = item.variant_title;
    return !v || v === 'Default Title' ? '' : v.replace(/\s*\/\s*NIE\s*$/i, '').replace(/\s*\/\s*TAK\s*$/i, ' ' + tx.with_inscription);
  }
  /* 6.10 (Aleksandra): the letter text shows as "Tre\u015B\u0107 listu:" (locale batida.cart.letter_label via the bridge's cart_drawer.letter_label) - display only, the property key Message-Wiadomosc stays as it is (FoodSoft and the Hub read it) */ function propsOf(
    item
  ) {
    if (!item.properties) return '';
    var bits = [];
    return (
      Object.keys(item.properties).forEach(function (k) {
        k.charAt(0) !== '_' &&
          k !== 'candles' &&
          item.properties[k] &&
          bits.push((k === 'Message-Wiadomosc' || k === 'message' ? tx.letter_label : k) + ': ' + item.properties[k]);
      }),
      bits.join(' \xB7 ')
    );
  }
  function imgOf(item) {
    var u = item.featured_image && item.featured_image.url;
    return !u || u.indexOf('cdn.shop') === -1 ? u || '' : u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=160&format=webp';
  }
  /* 29.09 (Aleksandra): the InPost fee line sits in its own "Dostawa" block after the products; Degustacja and lines without a photo get an icon tile (window.batidaIcon); a line shows its price before order / code discounts, the discounts are rows above "Suma". */ function isFee(
    item
  ) {
    var c = window.__batidaInpost;
    return !!c && (item.variant_id === parseInt(c.vid, 10) || (!!c.handle && item.handle === c.handle));
  }
  function isDeg(item) {
    return item.handle === 'degustacja-slubna';
  }
  function tile(item) {
    var n = isFee(item) ? 'paczkomat' : isMerch(item) ? 'koszulka' : isDeg(item) ? 'degustacja' : 'cukiernia',
      h = window.batidaIcon ? window.batidaIcon(n, 36) : '';
    return '<span class="bk-tile bk-tile--' + n + '" data-bk-icon aria-hidden="true">' + h + '</span>';
  }
  function deliveryBlock(list) {
    return list.length
      ? '<div class="batida-cart-drawer__delivery"><p class="batida-cart-drawer__delivery__h">' +
          escapeHtml(tx.delivery) +
          '</p>' +
          list.map(renderLine).join('') +
          '</div>'
      : '';
  }
  /* 28.10 (Aleksandra, "Zestaw prezentowy - skomponuj sam"): the lines of one gift share the hidden property _gift_id
     (assets/batida-gift-builder.js). They show as ONE block "Prezent N: karton średni różowy + 7 produktów" with the list,
     the card text and one "Usuń prezent" that removes all its lines in one /cart/update.js; no +/- inside a gift (one
     changed line would break the gift). Box = a line of the product 11035526037843 (the discount Function uses the same id). */
  var GIFT_BOX_PID = 11035526037843,
    GIFT_COLOURS = { 'ma\u0142y': 'kremowy', '\u015Bredni': 'r\u00F3\u017Cowy', 'du\u017Cy': 'kremowy', 'najwi\u0119kszy': 'czarny' },
    lastCart = null;
  function giftOf(item) {
    return (item && item.properties && item.properties._gift_id) || '';
  }
  function giftPlural(n) {
    var d = n % 10,
      h = n % 100;
    return n === 1 ? 'produkt' : d >= 2 && d <= 4 && (h < 10 || h >= 20) ? 'produkty' : 'produkt\u00F3w';
  }
  function giftTitle(lines) {
    var p = lines[0].properties || {},
      box = lines.filter(function (i) { return i.product_id === GIFT_BOX_PID; })[0],
      units = lines.reduce(function (s, i) { return i.product_id === GIFT_BOX_PID ? s : s + i.quantity; }, 0),
      bn = box ? String(box.variant_title || '').toLowerCase() : '';
    return (p.Prezent || 'Prezent') + ': ' + (box ? 'karton ' + (bn + ' ' + (GIFT_COLOURS[bn] || '')).trim() + ' + ' : '') + units + ' ' + giftPlural(units);
  }
  function giftBlock(lines) {
    var p = lines[0].properties || {},
      box = lines.filter(function (i) { return i.product_id === GIFT_BOX_PID; })[0] || lines[0],
      img = imgOf(box),
      total = lines.reduce(function (s, i) { return s + (i.original_line_price != null ? i.original_line_price : i.line_price); }, 0),
      list = lines
        .filter(function (i) { return i.product_id !== GIFT_BOX_PID; })
        .map(function (i) { return '<li>' + escapeHtml(i.product_title || i.title) + (i.quantity > 1 ? ' \u00D7 ' + i.quantity : '') + '</li>'; })
        .join('');
    return (
      '<div class="batida-cart-drawer__gift" data-gift-id="' + escapeHtml(giftOf(lines[0])) + '"><span class="batida-cart-drawer__line__img">' +
      (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : tile(box)) +
      '</span><div class="batida-cart-drawer__line__body"><p class="batida-cart-drawer__line__title">' + escapeHtml(giftTitle(lines)) + '</p>' +
      (list ? '<ul class="batida-cart-drawer__gift__list">' + list + '</ul>' : '') +
      (p.Bilecik ? '<p class="batida-cart-drawer__line__variant">Bilecik: ' + escapeHtml(p.Bilecik) + '</p>' : '') +
      (p['Etykieta firmowa'] ? '<p class="batida-cart-drawer__line__variant">Etykieta firmowa: ' + escapeHtml(p['Etykieta firmowa']) + '</p>' : '') +
      '<p class="batida-cart-drawer__line__price">' + formatPLN(total) + '</p><button type="button" class="batida-cart-drawer__gift__rm" data-batida-gift-remove="' +
      escapeHtml(giftOf(lines[0])) + '">Usu\u0144 prezent</button></div></div>'
    );
  }
  /* the cart lines in cart order, each gift as one block where its first line is */
  function linesHtml(items) {
    var done = {};
    return items
      .map(function (i) {
        var g = giftOf(i);
        if (!g) return renderLine(i);
        if (done[g]) return '';
        done[g] = 1;
        return giftBlock(items.filter(function (x) { return giftOf(x) === g; }));
      })
      .join('');
  }
  function giftKeys(g) {
    return ((lastCart && lastCart.items) || []).filter(function (i) { return giftOf(i) === g; }).map(function (i) { return i.key; });
  }
  function removeKeys(keys) {
    var upd = {};
    keys.forEach(function (k) { upd[k] = 0; });
    return __dRetry(function () {
      return __dTimed(__dRoot() + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: upd })
      }).then(__dJson);
    })
      .then(fetchAndRender)
      .catch(function (e) {
        __dFail('drawer_change', e);
        return fetchAndRender();
      });
  }
  function discounts(d, cart) {
    var box = d.querySelector('[data-batida-cart-discounts]');
    if (!box) return;
    var m = {},
      order = [];
    function add(t, a) {
      if (!t || !a) return;
      if (m[t] == null) {
        m[t] = 0;
        order.push(t);
      }
      m[t] += a;
    }
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      add(a.title, a.total_allocated_amount);
    });
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        add(a.discount_application && a.discount_application.title, a.amount);
      });
    });
    box.innerHTML = order
      .map(function (t) {
        return '<p><span>' + escapeHtml(tx.discount_row.replace('[title]', t)) + '</span><span>&minus;' + formatPLN(m[t]) + '</span></p>';
      })
      .join('');
    box.hidden = !order.length;
  }
  function renderLine(item) {
    var img = imgOf(item),
      imgTag =
        img && !isDeg(item)
          ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title || item.title) + '" loading="lazy">'
          : tile(item),
      v = variantOf(item),
      p = propsOf(item),
      k = escapeHtml(item.key),
      u = escapeHtml(item.url || '');
    return (
      '<div class="batida-cart-drawer__line" data-line-key="' +
      k +
      '"><a class="batida-cart-drawer__line__img" href="' +
      u +
      '">' +
      imgTag +
      '</a><div class="batida-cart-drawer__line__body"><p class="batida-cart-drawer__line__title"><a href="' +
      u +
      '">' +
      escapeHtml(item.product_title || item.title) +
      '</a></p>' +
      (isMerch(item) ? '<p class="batida-cart-drawer__line__pre">' + escapeHtml(tx.merch_preorder) + '</p>' : '') +
      (v ? '<p class="batida-cart-drawer__line__variant">' + escapeHtml(v) + '</p>' : '') +
      (p ? '<p class="batida-cart-drawer__line__variant">' + escapeHtml(p) + '</p>' : '') +
      '<p class="batida-cart-drawer__line__price">' +
      formatPLN(item.original_line_price != null ? item.original_line_price : item.line_price) +
      '</p><div class="batida-cart-drawer__line__qty"><button type="button" data-batida-cart-qty="-1" data-line-key="' +
      k +
      '">&minus;</button><input type="text" value="' +
      item.quantity +
      '" readonly><button type="button" data-batida-cart-qty="+1" data-line-key="' +
      k +
      '">+</button></div></div><button type="button" class="batida-cart-drawer__line__remove" data-batida-cart-remove data-line-key="' +
      k +
      '" aria-label="' +
      tx.remove +
      '"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg></button></div>'
    );
  }
  var lastBadgeCount = -1;
  function ensureBadgeIn(link, count) {
    var badge2 = link.querySelector('.' + BADGE_CLASS);
    count > 0
      ? (badge2 ||
          ((badge2 = document.createElement('span')),
          (badge2.className = BADGE_CLASS),
          badge2.setAttribute('aria-hidden', 'true'),
          link.appendChild(badge2)),
        badge2.textContent !== String(count) &&
          ((badge2.textContent = String(count)),
          badge2.classList.add('is-pulse'),
          setTimeout(function () {
            badge2.classList.remove('is-pulse');
          }, 250)),
        (badge2.hidden = !1))
      : badge2 && (badge2.hidden = !0);
  }
  function badge(cart) {
    var count = cart && typeof cart.item_count == 'number' ? cart.item_count : 0;
    ((lastBadgeCount = count),
      document
        .querySelectorAll(
          'a[href$="/cart"]:not([data-batida-cart-skip]), a.header__mobile__button[href$="/cart"]:not([data-batida-cart-skip]), a.navlink--cart:not([data-batida-cart-skip])'
        )
        .forEach(function (link) {
          ensureBadgeIn(link, count);
        }));
  }
  function reapplyBadge() {
    lastBadgeCount < 0 ||
      document
        .querySelectorAll(
          'a[href$="/cart"]:not([data-batida-cart-skip]), a.header__mobile__button[href$="/cart"]:not([data-batida-cart-skip]), a.navlink--cart:not([data-batida-cart-skip])'
        )
        .forEach(function (link) {
          ensureBadgeIn(link, lastBadgeCount);
        });
  }
  /* 2.10 (Astra speed report PERF-01): renderCart draws a cart we already have; theme:cart:change carries the full cart, so the drawer no longer re-reads /cart.js for it */ function renderCart(
    cart
  ) {
    var d = getDrawer();
    lastCart = cart;
    if (!d) return cart;
    var items = d.querySelector('[data-batida-cart-items]'),
      footer = d.querySelector('[data-batida-cart-footer]'),
      empty = d.querySelector('[data-batida-cart-empty]'),
      sub = d.querySelector('[data-batida-cart-subtotal]');
    return (
      cart.item_count === 0
        ? ((items.innerHTML = ''), footer && (footer.hidden = !0), empty && (empty.hidden = !1))
        : ((items.innerHTML =
            linesHtml(
              cart.items.filter(function (i) {
                return !isFee(i);
              })
            ) + deliveryBlock(cart.items.filter(isFee))),
          footer && (footer.hidden = !1),
          empty && (empty.hidden = !0),
          sub && (sub.textContent = formatPLN(cart.total_price)),
          discounts(d, cart)),
      badge(cart),
      cart
    );
  }
  /* Horizon P4 (D9): deadline + one retry + message + retry button */ var __dT = {
    pl: ['Nie uda\u0142o si\u0119 wczyta\u0107 koszyka.', 'Spr\u00F3buj ponownie'],
    en: ['The cart could not be loaded.', 'Try again'],
    de: ['Der Warenkorb konnte nicht geladen werden.', 'Erneut versuchen'],
    fr: ["Le panier n'a pas pu \u00EAtre charg\u00E9.", 'R\u00E9essayer'],
    uk: [
      '\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u0448\u0438\u043A.',
      '\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0449\u0435 \u0440\u0430\u0437'
    ]
  }[__batidaLang] || ['Nie uda\u0142o si\u0119 wczyta\u0107 koszyka.', 'Spr\u00F3buj ponownie'];
  function __dRoot() {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  }
  function __dTimed(url, opts, ms) {
    if (typeof AbortController != 'function') return fetch(url, opts);
    var c = new AbortController(),
      tm = setTimeout(function () {
        c.abort();
      }, ms || 10000);
    opts = opts || {};
    opts.signal = c.signal;
    return fetch(url, opts).then(
      function (r) {
        clearTimeout(tm);
        return r;
      },
      function (e) {
        clearTimeout(tm);
        throw e;
      }
    );
  }
  function __dLog(code, e) {
    try {
      window.clarity && (clarity('set', 'cart_err', code), clarity('event', 'cart_error'));
    } catch (x) {}
    try {
      console.warn('[batida-drawer]', code, (e && e.message) || e);
    } catch (x) {}
  }
  function __dJson(r) {
    if (!r.ok) throw new Error('http ' + r.status);
    return r.json();
  }
  function __dRetry(fn) {
    return fn().catch(function () {
      return new Promise(function (r) {
        setTimeout(r, 500);
      }).then(fn);
    });
  }
  function __dFail(code, e) {
    __dLog(code, e);
    var d = getDrawer();
    if (!d) return;
    setDrawerError(__dT[0]);
    var er = d.querySelector('[data-batida-cart-error]');
    if (er && !er.querySelector('[data-batida-cart-retry]')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-batida-cart-retry', '');
      b.textContent = __dT[1];
      b.style.cssText =
        'margin-left:8px;background:0 0;border:0;padding:0;font:inherit;color:inherit;text-decoration:underline;cursor:pointer';
      er.appendChild(b);
    }
  }
  function fetchAndRender() {
    return __dRetry(function () {
      return __dTimed(__dRoot() + '/cart.js', { credentials: 'same-origin' }).then(__dJson);
    })
      .then(function (c) {
        setDrawerError(null);
        return renderCart(c);
      })
      .catch(function (e) {
        __dFail('drawer_read', e);
      });
  }
  function changeQty(key, qty) {
    var gl = ((lastCart && lastCart.items) || []).filter(function (i) { return i.key === key; })[0], g = giftOf(gl);
    if (g) return qty > 0 ? fetchAndRender() : removeKeys(giftKeys(g));   // 28.10: a gift line never changes alone
    return __dRetry(function () {
      return __dTimed(__dRoot() + '/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(__dJson);
    })
      .then(fetchAndRender)
      .catch(function (e) {
        __dFail('drawer_change', e);
        return fetchAndRender();
      });
  }
  function collectMainItem(form) {
    var fd = new FormData(form),
      id = fd.get('id'),
      quantity = parseInt(fd.get('quantity'), 10) || 1,
      properties = {};
    for (var pair of fd.entries()) {
      var m = pair[0].match(/^properties\[(.+)\]$/);
      m && pair[1] && (properties[m[1]] = pair[1]);
    }
    try {
      ['#batida-napis-text', '#bp_text'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!(!el || form.contains(el))) {
          var pv = (el.value || '').trim();
          if (pv) {
            var pm = (el.name || '').match(/^properties\[(.+)\]$/);
            pm && (properties[pm[1]] || (properties[pm[1]] = pv));
          }
        }
      });
    } catch {}
    var item = { id, quantity };
    return (Object.keys(properties).length > 0 && (item.properties = properties), item);
  }
  function collectCrossProducts() {
    var items = [];
    return (
      document.querySelectorAll('.cross-product').forEach(function (cp) {
        var cb = cp.querySelector('.cross-product__checkbox') || cp.querySelector('input[type="checkbox"]');
        if (!(!cb || !cb.checked)) {
          var variantId = cb.getAttribute('data-variant-id');
          if (variantId) {
            var properties = {},
              msgEl = document.querySelector('textarea[name="properties[_Message-Wiadomosc]"]'),
              candlesEl = document.querySelector('.cross-product__input-text--candles'),
              isLetterCp =
                msgEl &&
                (cp.contains(msgEl) ||
                  (msgEl.closest('.batida-perso-expanded') && msgEl.closest('.batida-perso-expanded').previousElementSibling === cp)),
              isCandlesCp =
                candlesEl &&
                (cp.contains(candlesEl) ||
                  (candlesEl.closest('.batida-perso-expanded') &&
                    candlesEl.closest('.batida-perso-expanded').previousElementSibling === cp));
            if (!isLetterCp && !isCandlesCp) {
              var handle = '';
              (cp.className || '').split(/\s+/).forEach(function (c) {
                var m = c.match(/^cross-product--(.+)$/);
                m && (handle = m[1]);
              });
              var __ch = cp.getAttribute('data-canonical-handle');
              (__ch && (handle = __ch),
                handle === 'napisz-swoj-list' ? (isLetterCp = !!msgEl) : handle === 'swieczka-cyferka' && (isCandlesCp = !!candlesEl));
            }
            if (
              (isLetterCp && msgEl && msgEl.value && (properties.message = msgEl.value),
              isCandlesCp && candlesEl && candlesEl.value && (properties.candles = candlesEl.value),
              isCandlesCp &&
                Array.isArray(window.__batidaCandleSelections) &&
                window.__batidaCandleSelections.length > 0 &&
                window.__batidaCandleVariantMap)
            ) {
              var __sel = window.__batidaCandleSelections,
                __vmap = window.__batidaCandleVariantMap,
                __grouped = {};
              (__sel.forEach(function (__d) {
                __grouped[__d] = (__grouped[__d] || 0) + 1;
              }),
                Object.keys(__grouped).forEach(function (__d) {
                  var __v = __vmap[__d];
                  __v &&
                    __v.id &&
                    items.push({ id: parseInt(__v.id, 10), quantity: __grouped[__d], properties: { candles: __sel.join('') } });
                }));
              return;
            }
            var __qtyInp = (function () {
                var __ch2 = cp.getAttribute('data-canonical-handle') || ((cp.className || '').match(/cross-product--(\S+)/) || [])[1],
                  __r = __ch2 && document.querySelector('.batida-perso-row[data-handle="' + __ch2 + '"]'),
                  __ex = __r && __r.nextElementSibling;
                return __ex && __ex.querySelector('.cross-product__input');
              })(),
              __qty = __qtyInp ? Math.max(1, parseInt(__qtyInp.value, 10) || 1) : 1,
              item = { id: parseInt(variantId, 10), quantity: __qty };
            (Object.keys(properties).length > 0 && (item.properties = properties), items.push(item));
          }
        }
      }),
      items
    );
  }
  function setDrawerError(msg) {
    var d = getDrawer();
    if (!d) return;
    var p = d.querySelector('.batida-cart-drawer__panel');
    if (!p) return;
    var e = d.querySelector('[data-batida-cart-error]');
    if (msg) {
      if (!e) {
        e = document.createElement('div');
        e.className = 'batida-cart-drawer__error';
        e.setAttribute('data-batida-cart-error', '');
        var h = p.querySelector('.batida-cart-drawer__header');
        h && h.nextSibling ? p.insertBefore(e, h.nextSibling) : p.insertBefore(e, p.firstChild);
      }
      e.textContent = msg;
      e.hidden = !1;
    } else if (e) {
      e.textContent = '';
      e.hidden = !0;
    }
  }
  function recoverAtc(items, atc) {
    var failed = 0,
      cartRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, ''),
      p = Promise.resolve();
    items.forEach(function (it) {
      p = p.then(function () {
        return fetch(cartRoot + '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [it] })
        })
          .then(function (r) {
            r.ok || failed++;
          })
          .catch(function () {
            failed++;
          });
      });
    });
    return p.then(function () {
      atc && atc.classList.remove('is-loading');
      return fetch(cartRoot + '/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (fullCart) {
          try {
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: fullCart } }));
          } catch (e) {}
          openDrawer();
          failed > 0 &&
            setDrawerError(
              __batidaDrawerT('addon_unavailable', 'Niektóre produkty nie były już dostępne i nie zostały dodane do koszyka.')
            );
        })
        .catch(function () {
          openDrawer();
          failed > 0 &&
            setDrawerError(
              __batidaDrawerT('addon_unavailable', 'Niektóre produkty nie były już dostępne i nie zostały dodane do koszyka.')
            );
        });
    });
  }
  function handleAtcSubmit(e) {
    var form = e.target;
    if (!(!form || !form.matches || !form.matches('form[action$="/cart/add"]')) && form.getAttribute('data-batida-bypass') !== '1') {
      var atc = form.querySelector('.btn--add-to-cart, button[name="add"]');
      if (atc && atc.disabled) {
        e.preventDefault();
        return;
      }
      (e.preventDefault(), e.stopPropagation(), atc && atc.classList.add('is-loading'));
      var items = [collectMainItem(form)].concat(collectCrossProducts());
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(function (r) {
          return r.ok
            ? r.json()
            : r.json().then(function (j) {
                throw new Error(j.description || j.message || 'Add to cart failed');
              });
        })
        .then(function (data) {
          (atc && atc.classList.remove('is-loading'), setDrawerError(null));
          /* v109 (2026-05-30): BS-30 fix — dispatch theme:cart:change with the FULL cart (fetch /cart.js) instead of the raw /cart/add.js response (which lacks total_price/item_count and made the header Totals render "0 zl (undefined)" after ATC). On fetch failure, skip the dispatch (header stays as-is, never undefined) and still open the drawer. */ var __cartRoot =
            ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
          fetch(__cartRoot + '/cart.js', { credentials: 'same-origin' })
            .then(function (r) {
              return r.json();
            })
            .then(function (fullCart) {
              try {
                document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: fullCart } }));
              } catch (e) {}
              openDrawer();
            })
            .catch(function () {
              openDrawer();
            });
        })
        .catch(function (err) {
          (atc && atc.classList.remove('is-loading'), console.error('[batida-drawer] ATC error:', err), recoverAtc(items, atc));
        });
    }
  }
  function init() {
    (ensureDrawer(),
      document.body.addEventListener(
        'click',
        function (e) {
          var t = e.target,
            cl = t.closest && t.closest('a[href$="/cart"], a[href*="/cart?"], a[href*="/cart#"]');
          if (cl && !cl.hasAttribute('data-batida-cart-skip')) {
            (e.preventDefault(), openDrawer());
            return;
          }
          if (t.closest && t.closest('[data-batida-cart-close]')) {
            closeDrawer();
            return;
          }
          var qb = t.closest && t.closest('[data-batida-cart-qty]');
          if (qb) {
            var k = qb.getAttribute('data-line-key'),
              d = parseInt(qb.getAttribute('data-batida-cart-qty'), 10) || 0,
              inp = document.querySelector('.batida-cart-drawer__line[data-line-key="' + k + '"] input');
            if (!inp) return;
            var nq = Math.max(0, (parseInt(inp.value, 10) || 0) + d);
            changeQty(k, nq);
            return;
          }
          if (t.closest && t.closest('[data-batida-cart-retry]')) {
            setDrawerError(null);
            fetchAndRender();
            return;
          }
          var gb = t.closest && t.closest('[data-batida-gift-remove]');
          if (gb) {
            gb.disabled = !0;
            removeKeys(giftKeys(gb.getAttribute('data-batida-gift-remove')));
            return;
          }
          var rb = t.closest && t.closest('[data-batida-cart-remove]');
          if (rb) {
            changeQty(rb.getAttribute('data-line-key'), 0);
            return;
          }
        },
        !0
      ),
      document.addEventListener('keydown', function (e) {
        var d = getDrawer();
        if (d && d.classList.contains('is-open')) {
          if (e.key === 'Escape') closeDrawer();
          else if (e.key === 'Tab') {
            var f = __batidaGetFocusable(d);
            if (f.length > 1) {
              var first = f[0],
                last = f[f.length - 1];
              if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                try {
                  last.focus();
                } catch {}
              } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                try {
                  first.focus();
                } catch {}
              }
            }
          }
        }
      }),
      document.body.addEventListener('submit', handleAtcSubmit, !0),
      (window.batidaCart && window.batidaCart.read
        ? window.batidaCart.read()
        : fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '') + '/cart.js').then(
            function (r) {
              return r.json();
            }
          )
      )
        .then(badge)
        .catch(function () {}) /* Horizon P4: the badge read is the shared /cart.js read of batida-compat (one read per page, not two) */,
      [300, 800, 1500, 3e3, 6e3].forEach(function (ms) {
        setTimeout(reapplyBadge, ms);
      }),
      document.addEventListener('theme:cart:change', function (ev) {
        var c = ev && ev.detail && ev.detail.cart;
        if (c && Array.isArray(c.items) && typeof c.item_count == 'number' && typeof c.total_price == 'number')
          setTimeout(function () {
            renderCart(c);
          }, 0);
        else setTimeout(fetchAndRender, 100);
      }));
    try {
      var __mo = null,
        __idle = null,
        __stop = function () {
          if (__mo) {
            try {
              __mo.disconnect();
            } catch (e) {}
            __mo = null;
          }
        },
        __bump = function () {
          clearTimeout(__idle);
          __idle = setTimeout(__stop, 4000);
        },
        __arm = function () {
          if (__mo) return;
          try {
            __mo = new MutationObserver(function () {
              reapplyBadge();
              __bump();
            });
            __mo.observe(document.body, { childList: !0, subtree: !0 });
            __bump();
          } catch (e) {}
        };
      __arm();
      document.addEventListener('theme:cart:change', function () {
        reapplyBadge();
        __arm();
      });
    } catch {}
    ((window.__batidaOpenCart = openDrawer), (window.__batidaCloseCart = closeDrawer), (window.__batidaRefreshCart = fetchAndRender));
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
//# sourceMappingURL=/cdn/shop/t/110/assets/batida-drawer.js.map?v=24838439034757427601780127144
